import { SearchOptionLinksObject, SearchApi } from 'components/SA/SearchProvider/types'
import { useEffect, useState } from 'react'

type UsePopularSearchesParams = {
  searchService: SearchApi
  maxPopularSearches?: number
}

const usePopularSearches = ({ searchService, maxPopularSearches }: UsePopularSearchesParams) => {
  const [popularSearches, setPopularSearches] = useState<ReadonlyArray<SearchOptionLinksObject>>([])

  const getPopularSearches = async () => {
    const popularSearchesResponse = await searchService.fetchSearchProviderRecommendations({
      podId: 'trending-searches',
      section: 'Search Suggestions',
      numResults: maxPopularSearches,
    })

    if (popularSearchesResponse.success) {
      const lowerCasePopularSearches = popularSearchesResponse.payload.data.recommendations.map(
        ({ label, link }) => ({
          label: label?.toLowerCase(),
          link,
        })
      )
      setPopularSearches(lowerCasePopularSearches)
      return
    }

    setPopularSearches([])
  }

  useEffect(() => {
    getPopularSearches()
  }, [])

  return { popularSearches, getPopularSearches, setPopularSearches }
}

export default usePopularSearches
